import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function postCambiarContrasenia({ jsonBody }) {
  let response = {};

  await superagent
    .post(`${webservice}/postCambiarContrasenia`)
    .set(('Content-Type': 'application/json'))
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .send(jsonBody)
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
